/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useMemo, useContext } from 'react';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';

import { Avatar, Icon, Title, Space } from 'components';

import FormContext from '../../FormContext';
import PostTitle from './PostTitle';

interface PageHeaderProps {
  openHistoryModal: () => void;
  navigateBack: () => void;
  pageTitle: string;
}

const PageHeader = ({
  openHistoryModal,
  navigateBack,
  pageTitle,
}: PageHeaderProps) => {
  const { md } = useBreakpoint();

  const { fetchedUserState } = useContext(FormContext);

  // If modifying an existing user, use their info for Avatar; if it's the New
  // User screen, there will be no fetchedUserState and a generic avatar will
  // be shown instead.
  const preTitle = <StyledAvatar user={fetchedUserState} />;

  return (
    <StyledPageHeader $md={md}>
      <Space wrap>
        <button onClick={navigateBack}>
          <Icon type="arrowLeftThin" color="black" offset={[0, 2]} />
        </button>

        {preTitle}

        <StyledTitle level={1} hideMargin>
          {pageTitle}
        </StyledTitle>
      </Space>

      <PostTitle openHistoryModal={openHistoryModal} />
    </StyledPageHeader>
  );
};

export default PageHeader;

const StyledAvatar = styled(Avatar)`
  margin-right: 12px;
`;

const StyledTitle = styled(Title)``;

const StyledPageHeader = styled.div<{ $md: boolean }>`
  display: grid;
  grid-template-columns: ${({ $md }) => ($md ? 'auto 1fr' : '1fr')};
  grid-gap: 12px;
  align-items: center;
  margin-top: 10px;
  width: 100%;
  & > *:last-child {
    display: flex;
    align-items: center;
  }
`;
